import { service } from '@/utils/request'
// var outUrl = 'http://apitest.ibabygroup.cn'
export default {
  	//获取列表
  	getDataList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/list',
	      method: 'get',
	      params: data
	    })
	},
  	addData: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/add',
	      method: 'post',
	      data: data
	    })
	},
  	getDetail: (path) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/'+path,
	      method: 'get'
	    })
	},
  	updateData: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/update',
	      method: 'post',
	      data: data
	    })
	},
  	deleteData: (path) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/delete/' + path,
	      method: 'post'
	    })
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/coursetypemanage.js